import React from 'react'
import { useConfig } from 'msp-integrations'
import Icons from '@atoms/Icons/Icons'
import DynamicTag from '@molecules/DynamicTag/DynamicTag'
import { Button } from '@atoms/Button'
import * as T from './PageActionPlaceholder.types'

const PageActionPlaceHolder = ({
  heading,
  text = '',
  iconName = null,
  iconSize = '3xl',
  buttonText = '',
  buttonProps = {},
  onButtonClick
}: T.PageActionPlaceholderProps) => {
  const {
    theme: { mspComponents }
  } = useConfig()
  const { pageActionPlaceHolder: S } = mspComponents
  return (
    <div className={S.Wrapper}>
      {iconName && (
        <div className={S.IconWrapper}>
          <Icons iconName={iconName} size={iconSize} />
        </div>
      )}
      {heading && (
        <DynamicTag componentTagName='Headline' tag='h6' className={S.Headline}>
          {heading}
        </DynamicTag>
      )}
      {text && <div className={S.ContentText}>{text}</div>}
      {buttonText && onButtonClick && (
        <div className={S.ActionsWrapper}>
          <Button type={'primary'} onClick={onButtonClick} {...buttonProps}>
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  )
}

export default PageActionPlaceHolder
